import { InputNumber } from 'antd';
import cx from 'classnames';
import React from 'react';
import { noneDecimalFormatter } from '../../../../../../../Helper';
import { LocalPrinterSetupInfoStore } from '../../../../../../../model/DeviceAdminModel';
import { useStoreDispatch, useStoreSelector } from '../../../../../../../store';
import { ControllerMisc, ControllerReporting, ErrorTabs } from '../../../../../../../store/deviceControl/controller/actionTypes';
import {
	setControllerError,
	setControllerMiscSystemSetupAction,
	setControllerReportingSetupAction,
} from '../../../../../../../store/deviceControl/controller/actions';
import { selectError, selectLocalPrinterSetupInfo } from '../../../../../../../store/deviceControl/controller/selectors';
import { Select } from '../../../../../../common';
import styles from '../reporting.module.scss';

const controllerReportingLinesPerPageInputId = 'controllerReportingLinesPerPageInput';
const controllerReportingLanguageDropdownId = 'controllerReportingLanguageDropdown';

const LocalPrinterSetup: React.FC = () => {
	//#region state management variables
	const dispatch = useStoreDispatch();
	const localPrinterSetupInfo: LocalPrinterSetupInfoStore = useStoreSelector<LocalPrinterSetupInfoStore>(selectLocalPrinterSetupInfo);
	const error: ErrorTabs = useStoreSelector<ErrorTabs>(selectError);
	//#endregion

	const handleChangeControllerReportingSetup = (value: ControllerReporting) => {
		dispatch(
			setControllerReportingSetupAction({
				...value,
			})
		);
	};

	const handleChangeControllerMiscSystemSetup = (value: ControllerMisc) => {
		dispatch(
			setControllerMiscSystemSetupAction({
				...value,
			})
		);
	};

	const handleChangeLinesPerPage = (value: string | number) => {
		const linesPerPage = Number(value);
		dispatch(setControllerError({ linesPerPageForFormFeed: false, message: '' }));
		if ((linesPerPage !== 0 && linesPerPage < 40) || linesPerPage > 255) {
			dispatch(setControllerError({ linesPerPageForFormFeed: true }));
		}
		handleChangeControllerReportingSetup({ LocalPrinterLinesPerPage: linesPerPage });
	};

	return (
		<div className={styles.localPrinterSetup}>
			<div>
				<label htmlFor={controllerReportingLinesPerPageInputId}>{_('LinesPerPageForFormFeed')}:</label>
				<InputNumber
					id={controllerReportingLinesPerPageInputId}
					min={0}
					max={255}
					maxLength={3}
					onChange={handleChangeLinesPerPage}
					value={localPrinterSetupInfo.linesPerPageForFormFeed}
					formatter={noneDecimalFormatter}
					className={cx({ [styles.errorInput]: error.linesPerPageForFormFeed })}
				/>
				<label>({_('0None40255')})</label>
				{error.linesPerPageForFormFeed && <span className={styles.errorText}>{_('LinesPerPageMustBe0Or40To255')}</span>}
			</div>
			<div className={styles.localPrinterSetupLanguage}>
				<label htmlFor={controllerReportingLanguageDropdownId}>{_('Language')}:</label>
				<Select
					id={controllerReportingLanguageDropdownId}
					onChange={value => handleChangeControllerMiscSystemSetup({ LocalPrinterLanguage: Number(value) })}
					value={localPrinterSetupInfo.languageId}
					notUseCurrentParse
					options={localPrinterSetupInfo.languageOptions.map(x => ({ label: x.Name, value: x.Id }))}
					getPopupContainer={element => element}
					showSearch
				/>
				<div />
			</div>
		</div>
	);
};

export { LocalPrinterSetup };
